import { render, staticRenderFns } from "./Refrigerators_custom_02.vue?vue&type=template&id=62a53f22&scoped=true&"
import script from "./Refrigerators_custom_02.vue?vue&type=script&lang=js&"
export * from "./Refrigerators_custom_02.vue?vue&type=script&lang=js&"
import style0 from "./Refrigerators_custom_02.vue?vue&type=style&index=0&id=62a53f22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62a53f22",
  null
  
)

component.options.__file = "Refrigerators_custom_02.vue"
export default component.exports